<template>
  <div class="w-full flex flex-col flex-grow">
    <WorkingAndError :isWorking="isWorking" :error="responseError" />
    <div v-if="Array.isArray(logs) && logs.length > 10" class="w-full p-1 border-b flex items-center">
        <input v-model.trim="filter" type="search" class="w-full max-w-sm" placeholder="filter" />
    </div>
    <div class="w-full flex flex-col flex-grow items-center p-1">
      <div v-if="Array.isArray(logs) && logs.length > 0" class="w-full flex flex-col flex-auto flex-grow h-0 overflow-y-auto">
        <div v-for="log in filteredLogs" :key="log._id" class="w-full p-1">
            <div class="w-full flex flex-row items-center flex-wrap">
                <div class="w-44 min-w-44 text-left whitespace-normal truncate text-sky">
                  <div v-if="log.timestamp && isValid(parseISO(log.timestamp))">{{ format(parseISO(log.timestamp),'MMM d, yyyy h:mm a') }}</div>
                </div>
                <div class="flex-grow text-left whitespace-normal truncate">
                {{ log.logEntry }}
                </div>
            </div>
            </div>
            </div>
      <div v-else class="w-full text-center p-1 whitespace-normal text-sm font-semibold">
        No logs returned
        </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { parseISO, isValid, format } from 'date-fns'
export default {
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const isWorking = ref(false)
    const responseError = ref(null)
    const filter = ref('')

    // Clear filter when logs drop below 10 to prevent filter from disappearing with active filter
    watch(() => {
      return Array.isArray(props.logs) ? props.logs.length : 0
    }, (newLength) => {
      if (newLength < 10 && filter.value) {
        filter.value = ''
      }
    })

    const filteredLogs = computed(() => {
        if (!Array.isArray(props.logs)) {
            return []
        }
        
        if(filter.value) {
            const filterLower = filter.value.toLowerCase()
            const filterWords = filterLower.split(/\s+/).filter(word => word.length > 0)
            
            return props.logs.filter(log => {
                // Get formatted timestamp
                let formattedTimestamp = ''
                if (log.timestamp && isValid(parseISO(log.timestamp))) {
                    formattedTimestamp = format(parseISO(log.timestamp), 'MMM d, yyyy h:mm a').toLowerCase()
                }
                
                // Get log entry text
                const logEntryText = log.logEntry ? log.logEntry.toLowerCase() : ''
                
                // Combine timestamp and log entry for searching
                const searchableText = `${formattedTimestamp} ${logEntryText}`.trim()
                
                // All filter words must be found somewhere (in timestamp or logEntry)
                return filterWords.every(word => searchableText.includes(word))
            })
        } else {
            return props.logs
        }
    })

    return {
      isWorking,
      responseError,
      parseISO,
      isValid,
      format,
      filter,
      filteredLogs
    }
  }
}
</script>

<style scoped>
</style>